module.exports = __webpack_public_path__ + "static/media/aws.3bd8ff39.jpg";